import type { ChamferShapeBuildInput } from '../types/ChamferShapeBuildInput';
import { AngleDistanceChamferSolver } from '../solvers/AngleDistanceChamferSolver';
import { ChamferSolver } from '../solvers/ChamferSolver';
import { DistanceDistanceChamferSolver } from '../solvers/DistanceDistanceChamferSolver';
import { FaceFaceChamferSolver } from '../solvers/FaceFaceChamferSolver';
import { OffsetFaceChamferSolver } from '../solvers/OffsetFaceChamferSolver';
import { VertexChamferSolver } from '../solvers/VertexChamferSolver';

/**
 * 倒角 solver 注册表。
 */
export class ChamferSolverRegistry {
  /** 已注册 solver 集合。 */
  private readonly solvers: ChamferSolver[];

  /**
   * @param solvers 初始 solver 集合。
   */
  public constructor(solvers: ChamferSolver[] = [
    new AngleDistanceChamferSolver(),
    new DistanceDistanceChamferSolver(),
    new VertexChamferSolver(),
    new OffsetFaceChamferSolver(),
    new FaceFaceChamferSolver(),
  ]) {
    this.solvers = [...solvers];
  }

  /**
   * 按倒角类型查找 solver。
   *
   * @param type 倒角类型。
   * @returns 匹配的 solver。
   */
  public resolve(type: ChamferType): ChamferSolver {
    const solver = this.solvers.find((candidate) => candidate.supports(type));
    if (!solver) {
      throw new Error(`不支持的倒角类型: ${type}`);
    }
    return solver;
  }

  /**
   * 构建倒角 Shape。
   *
   * @param input 倒角求解输入。
   * @returns 倒角结果 Shape。
   */
  public buildShape(input: ChamferShapeBuildInput): unknown {
    return this.resolve(input.definition.type).build(input);
  }
}

/**
 * 默认倒角 solver 注册表。
 */
export const defaultChamferSolverRegistry = new ChamferSolverRegistry();

